







































































































































































































































































































































































































































































































































































































































































































































import BaseComponent from '@/core/base.component';
import {
  AdminDto,
  AdminListDto,
  AdminSendMessageDto,
  ConsultResponseDto,
  ConsultResponseUpdateDto,
  ReservationCheckTimeDto,
  ReservationCreateDto,
  ReservationDeleteReasonDto,
  ReservationUpdateDto,
} from '@/dto';
import {
  BEST_FOOD_CATEGORY,
  BRAND_CONSULT,
  CONST_BEST_FOOD_CATEGORY,
  CONST_RESERVATION_DELETE_REASON,
  CONST_RESERVATION_HOURS,
  RESERVATION_DELETE_REASON,
  RESERVATION_HOURS,
  RESERVATION_HOURS_JSON,
} from '@/services/shared';
import { Component, Vue } from 'vue-property-decorator';
import { getStatusColor } from '@/core/utils/status-color.util';
import SmsService from '@//services/sms.service';
import toast from '../../../../../resources/assets/js/services/toast.js';
import { BaseUser } from '@/services/shared/auth';
import AdminService from '@/services/admin.service';
import { CONST_YN, Pagination, YN } from '@/common';
import { PickcookCodeManagementDto } from '@/services/init/dto';
import ConsultResponseService from '@/services/pickcook/consult-response.service';
import CommonCodeService from '@/services/pickcook/common-code.service';
import ReservationService from '@/services/pickcook/reservation.service';
import FoodCategoryRatioChart from '@/modules/pickcook/consult-response/add-on/FoodCategoryRatioChart.vue';
import TimeRevenueChart from '@/modules/pickcook/consult-response/add-on/TimeRevenueChart.vue';
import GenderRevenueChart from '@/modules/pickcook/consult-response/add-on/GenderRevenueChart.vue';
import ResultRevenueChart from '@/modules/pickcook/consult-response/add-on/ResultRevenueChart.vue';

@Component({
  name: 'ConsultResponseDetail',
  components: {
    FoodCategoryRatioChart,
    TimeRevenueChart,
    GenderRevenueChart,
    ResultRevenueChart,
  },
})
export default class ConsultResponseDetail extends BaseComponent {
  private consultResponseDto = new ConsultResponseDto();
  private consultResponseUpdateDto = new ConsultResponseUpdateDto();
  private adminSendMessageDto = new AdminSendMessageDto();
  private brandConsultStatus: PickcookCodeManagementDto[] = [];
  private codeManagementDto = new PickcookCodeManagementDto();
  private paginationCode = new Pagination();
  private locationDetailInfo: any = [];
  private selectedFoodCategory = '';
  private bestFoodCategory: BEST_FOOD_CATEGORY[] = [
    ...CONST_BEST_FOOD_CATEGORY,
  ];

  private reservationCreateDto = new ReservationCreateDto();
  private reservationUpdateDto = new ReservationUpdateDto();
  private reservationDeleteReasonDto = new ReservationDeleteReasonDto();
  private reservationCheckTimeDto = new ReservationCheckTimeDto();
  private reservationTimes: any[] = [];
  private reservationDeleteReasons: RESERVATION_DELETE_REASON[] = [
    ...CONST_RESERVATION_DELETE_REASON,
  ];
  private selectDeleteReason = '';
  private otherDeleteReason = '';
  private deleteReasonText = '';

  private adminList: AdminDto[] = [];
  private adminSearchDto = new AdminListDto();
  private adminTotalCount = null;
  private paginationAdmin = new Pagination();
  private selectedAdmin: AdminDto = new AdminDto(BaseUser);

  private configOptions: any = {
    format: 'YYYY-MM-DD hh:mm A',
    icons: {
      time: 'far fa-clock',
      date: 'far fa-calendar',
      up: 'fas fa-arrow-up',
      down: 'fas fa-arrow-down',
      previous: 'fas fa-chevron-left',
      next: 'fas fa-chevron-right',
      today: 'fas fa-calendar-check',
      clear: 'far fa-trash-alt',
      close: 'far fa-times-circle',
    },
  };

  // get reservation time
  getReservationTimes(date: string) {
    this.reservationCheckTimeDto.reservationDate = date;
    ReservationService.getAvailableTimes(
      this.reservationCheckTimeDto,
    ).subscribe(res => {
      if (res) {
        this.reservationTimes = res.data;
      }
    });
  }

  // get status color
  getStatusColor(status: BRAND_CONSULT) {
    return getStatusColor(status);
  }

  // get common codes
  getCommonCodes() {
    this.codeManagementDto.category = 'BRAND_CONSULT';
    CommonCodeService.findAll(
      this.codeManagementDto,
      this.paginationCode,
    ).subscribe(res => {
      this.brandConsultStatus = res.data.items;
    });
  }

  // get location info detail
  getLocationInfoDetail() {
    if (this.consultResponseDto.proforma.hdong) {
      ConsultResponseService.getLocationInfoDetail(
        this.consultResponseDto.proforma.hdong.hdongCode,
      ).subscribe(res => {
        let filterArray = [...Object.values(res.data)];
        filterArray = filterArray.filter((arr: any) => {
          for (const filter of this.bestFoodCategory) {
            if (arr.mediumCategoryName.includes(filter)) {
              return true;
            }
          }
        });

        this.selectedFoodCategory = filterArray[0].mediumCategoryName;
        this.locationDetailInfo = filterArray.splice(0, 5);

        // console.log('this.locationDetailInfo', this.locationDetailInfo);
      });
    }
  }

  // get cateogry
  getCategory(category: string) {
    this.selectedFoodCategory = category;
  }

  findAdmin(isPagination: boolean) {
    if (!isPagination) {
      this.paginationAdmin.page = 1;
    }
    this.paginationAdmin.limit = 5;
    AdminService.findAll(this.adminSearchDto, this.paginationAdmin).subscribe(
      res => {
        this.adminList = res.data.items;
        this.adminTotalCount = res.data.totalCount;
      },
    );
  }

  selectAdmin(admin: AdminDto) {
    this.selectedAdmin = admin;
  }

  cancelSelection() {
    this.selectedAdmin = new AdminDto(BaseUser);
  }

  paginateSearch() {
    this.findAdmin(true);
  }

  // 담당자 본인으로 정하기
  assignYourselfAdmin() {
    ConsultResponseService.assignAdmin(this.consultResponseDto.id).subscribe(
      res => {
        this.findOne(this.consultResponseDto.id);
      },
    );
  }

  // 지도 가져오기
  // setMap(district: consultResponseDto) {
  //   const mapContainer = document.getElementById('map'),
  //     mapOption = {
  //       center: new window.kakao.maps.LatLng(district.lat, district.lon),
  //       level: 5,
  //       maxLevel: 6,
  //       minLevel: 3,
  //       mapTypeId: window.kakao.maps.MapTypeId.ROADMAP,
  //     };

  //   const map = new window.kakao.maps.Map(mapContainer, mapOption);
  //   const content = `<span class="badge badge-primary" style="font-size:21px;border-radius: 100px;opacity: 82%">${district.deliverySpaces.length}</span>`;
  //   const markerPosition = new window.kakao.maps.LatLng(
  //     district.lat,
  //     district.lon,
  //   );

  //   const customOverlay = new window.kakao.maps.CustomOverlay({
  //     position: markerPosition,
  //     content: content,
  //     // image: markerImage,
  //   });

  //   const circle = new window.kakao.maps.Circle({
  //     map: map,
  //     center: new window.kakao.maps.LatLng(district.lat, district.lon),
  //     strokeWeight: 2,
  //     strokeColor: '#FF00FF',
  //     strokeOpacity: 0.8,
  //     strokeStyle: 'dashed',
  //     fillColor: '#00EEEE',
  //     fillOpacity: 0.5,
  //   });
  //   circle.setRadius(1000);
  //   circle.setMap(map);
  //   customOverlay.setMap(map);
  // }

  findOne(id) {
    ConsultResponseService.findOne(id).subscribe(res => {
      if (res) {
        this.consultResponseDto = res.data;
        this.getLocationInfoDetail();
        this.consultResponseUpdateDto.consultStatus = this.consultResponseDto.consultStatus;
        this.consultResponseUpdateDto.description = this.consultResponseDto.description;
        if (
          this.consultResponseDto.reservation &&
          this.consultResponseDto.reservation.isCancelYn !== 'Y'
        ) {
          this.reservationUpdateDto.reservationDate = this.consultResponseDto.reservation.formatReservationDate;
          this.reservationUpdateDto.reservationTime = this.consultResponseDto.reservation.reservationTime;
          this.getReservationTimes(
            this.consultResponseDto.reservation.reservationDate
              .toString()
              .slice(0, 10),
          );
        }
      }
    });
  }

  // update consult response
  updateConsultResponse() {
    if (this.selectedAdmin) {
      this.consultResponseUpdateDto.adminId = this.selectedAdmin.no;
    }
    ConsultResponseService.update(
      this.$route.params.id,
      this.consultResponseUpdateDto,
    ).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  // create reservation
  createReservation() {
    this.reservationCreateDto.consultId = this.consultResponseDto.id;
    this.reservationCreateDto.reservationCode = this.consultResponseDto.reservationCode;
    ReservationService.create(this.reservationCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  // update reservation
  updateReservation() {
    ReservationService.update(
      this.consultResponseDto.reservation.id,
      this.reservationUpdateDto,
    ).subscribe(res => {
      if (res) {
        toast.success('변경완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  onSelectDeleteReason(value) {
    if (value !== RESERVATION_DELETE_REASON.ETC) {
      this.deleteReasonText = value;
      this.reservationDeleteReasonDto.deleteReasonEtc = '';
    } else {
      this.deleteReasonText = '';
    }
  }

  onSelectOtherReason(value) {
    this.deleteReasonText = value;
  }

  // cancel reservation
  cancelReservation() {
    ReservationService.deleteOne(
      this.consultResponseDto.reservation.id,
      this.reservationDeleteReasonDto,
    ).subscribe(res => {
      if (res) {
        toast.success('취소완료');
        this.$bvModal.hide('cancel_reservation');
        this.findOne(this.$route.params.id);
      }
    });
  }

  created() {
    const id = this.$route.params.id;
    this.findOne(id);
    this.getCommonCodes();
  }
}
